import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import { useSessionStore } from '@/deploy/stores/session.store';
import { DeployActivityBadge } from './DeployActivityBadge';
import styles from './DeployHeaderControls.module.scss';

interface NavItem { to: string; label: string; end?: boolean }

// Nav secondaire (pages non listées dans la sidebar : Logs, Paramètres…).
const EXTRA_NAV: NavItem[] = [
  { to: '/deploiement', label: 'Dashboard', end: true },
  { to: '/deploiement/deploy', label: 'Release' },
  { to: '/deploiement/containers', label: 'Containers' },
  { to: '/deploiement/environments/prod', label: 'Environnements' },
  { to: '/deploiement/environments/dev', label: 'Envs dev' },
  { to: '/deploiement/environments/beta', label: 'Slots bêta' },
  { to: '/deploiement/apis', label: 'APIs' },
  { to: '/deploiement/resource-packs', label: 'Resource Packs' },
  { to: '/deploiement/history', label: 'Historique' },
  { to: '/deploiement/logs', label: 'Logs' },
  { to: '/deploiement/settings', label: 'Paramètres' },
];

/**
 * Contrôles de l'espace Déploiement rendus dans la navbar du panel (haut, à droite),
 * uniquement quand on est dans l'espace Déploiement et connecté à recube-cicd :
 * engrenage (nav secondaire : Logs / Paramètres…) + « Sortir » (logout recube-cicd).
 */
export function DeployHeaderControls() {
  const isLoggedIn = useSessionStore((s) => s.isLoggedIn);
  const logout = useSessionStore((s) => s.logout);
  const [open, setOpen] = useState(false);

  if (!isLoggedIn) return null;

  return (
    <div className={styles.wrap}>
      <DeployActivityBadge />
      <div className={styles.menu}>
        <button
          type="button"
          className={`${styles.iconBtn} ${open ? styles.iconBtnActive : ''}`}
          onClick={() => setOpen((v) => !v)}
          title="Paramètres / navigation"
          aria-expanded={open}
        >
          <Settings size={18} strokeWidth={2} />
        </button>
        {open && (
          <>
            <div className={styles.backdrop} onClick={() => setOpen(false)} />
            <nav className={styles.dropdown}>
              {EXTRA_NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </>
        )}
      </div>
      <button type="button" className={styles.sortir} onClick={logout} title="Déconnexion recube-cicd">
        <LogOut size={15} strokeWidth={2} />
        <span>Sortir</span>
      </button>
    </div>
  );
}
